import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CartState } from './cart-state.model';

export const selectCartState = createFeatureSelector<CartState>('cart');

export const selectCart = createSelector(selectCartState, (entities) => entities);
